import { SeverShoppingCartModule } from './cart2/module';
const ServerShoppingCart = new SeverShoppingCartModule();
export default ServerShoppingCart;
